import { CommonModule } from '@angular/common';
import { Component, ContentChild, EventEmitter, Input, NgModule, OnInit, Output, ViewChild } from '@angular/core';
import { DxFormComponent, DxToolbarComponent, DxTreeListComponent } from 'devextreme-angular';
import { defaultTreeGridOptions, routes } from '../../models';
import { SharedModule } from '../../shared.module';
import { ActionBarComponent, ActionBarModule } from '../action-bar/action-bar.component';
import { GridFilterComponent, GridFilterModule } from '../grid-filter/grid-filter.component';
import { Router } from '@angular/router';
import { PageInfoService } from 'src/app/core/services/page-info.service';
import { ConfigurationService, IDataGridState } from 'src/app/core/services/configuration.service';
import { AuthorizationService } from 'src/app/core/services/authorization.service';
import { state } from '@angular/animations';

@Component({
  selector: 'app-tree-grid-view',
  templateUrl: './tree-grid-view.component.html',
  styleUrls: ['./tree-grid-view.component.scss']
})
export class TreeGridViewComponent implements OnInit {

@ViewChild(ActionBarComponent)
  private actionBarComponent!: ActionBarComponent;
  @ViewChild(GridFilterComponent)
  private gridFilterComponent!: GridFilterComponent;
  @ContentChild(DxTreeListComponent)
  private treeGrid!: DxTreeListComponent;
  @Input()
  public filterModel: any;
  @Input()
  public filterItems: any;
  @Input()
  public actionItems: any;
  @Input()
  public showFilter: boolean = true;
  @Input()
  public title!: string;
  @Output()
  public onSearch = new EventEmitter();
  public actionBar!: DxToolbarComponent;
  public filter!: DxFormComponent;
  @Input() public showHistoryItem: boolean = true;
  public currentPageUrl!: string;
  @Input()
  public GridId!: string ;

  private UserId : number;
  
  
  
  public dataGridState: IDataGridState = 
  {
    UserId : null,
    GridId : "",
    State : "",
  };

  constructor(private router: Router,
    private pageInfoService: PageInfoService,
    private configurationService: ConfigurationService,
    private authorizationService: AuthorizationService
  ) { 
    this.UserId = this.authorizationService.CurrentUser.Id;
  }
  
  public getGridStateData(){
    let grid = this.treeGrid?.instance?.element();
    if(!grid.id){
      let localState = localStorage.getItem(this.pageInfoService.getCurrentPageTitle());
      if(localState){
        this.treeGrid.instance.state(JSON.parse(localState));
    }
    }
    if(grid.id){
      this.configurationService.getDataGridStateByGridId(grid.id,this.UserId)
            .then((response:any)=>{
              if(response.Data){
                this.dataGridState.State = response.Data.State;
              if (this.treeGrid && this.treeGrid.instance && this.dataGridState.State) {
              this.treeGrid.instance.state(JSON.parse(this.dataGridState.State));
                }
              } 
            });  
    }
  }

  ngAfterContentInit(): void {
    this.treeGrid.instance.option(defaultTreeGridOptions);
  }
  ngAfterViewInit(): void {
    this.getGridStateData();
    this.actionBar = this.actionBarComponent.toolBar;
    this.filter = this.gridFilterComponent?.form;
    this.treeGrid.instance.option("columnChooser", { enabled: true });
  }
  
  ngOnInit(): void {
    this.dataGridState.UserId = this.UserId;
    this.dataGridState.GridId = this.GridId;
  }

  onSearchClicked(e: any){
    this.treeGrid?.instance.clearSelection();
    this.onSearch.emit(e);
  }

  onViewHistory = (e: any) =>{
    this.currentPageUrl = this.router.url;
    let currentModel : any = routes.get(this.currentPageUrl);
    this.router.navigate([`/auditTrails/${currentModel}`]);
   }

  ngOnDestroy(){
      this.dataGridState.GridId = this.treeGrid?.instance?.element().id;
    if(!this.dataGridState.GridId)
    {
     localStorage.setItem(this.pageInfoService.getCurrentPageTitle(), JSON.stringify(this.treeGrid.instance.state())); 
    }
    else{
      this.dataGridState.State = JSON.stringify(this.treeGrid.instance.state());
      this.configurationService.addDataGridStateGridID(this.dataGridState)
        .then((response : any )=> {
         // this.response;
         });
    }
  }

}

@NgModule({
  imports: [
    CommonModule,
    ActionBarModule,
    GridFilterModule,
    SharedModule
  ],
  declarations: [ TreeGridViewComponent ],
  exports: [ TreeGridViewComponent ]
})
export class TreeGridViewModule {

}


